webpackJsonp([64],{

/***/ "IfL1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3ATLU","url":"url___34G2w"};

/***/ }),

/***/ "tGCO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reduxAsyncConnect = __webpack_require__("5t3y");

var _reactRedux = __webpack_require__("RH2O");

var _FormattedMessage = __webpack_require__("bhzT");

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _config = __webpack_require__("iS9E");

var _link = __webpack_require__("wM8m");

var _link2 = _interopRequireDefault(_link);

var _NotFoundModule = __webpack_require__("IfL1");

var _NotFoundModule2 = _interopRequireDefault(_NotFoundModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, _ref) {
    var location = _ref.location;
    var pathname = location.pathname;

    return {
        baseUrl: (0, _config.getBaseUrl)(state),
        pathname: pathname
    };
};

var NotFound = function (_PureComponent) {
    (0, _inherits3.default)(NotFound, _PureComponent);

    function NotFound() {
        (0, _classCallCheck3.default)(this, NotFound);
        return (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).apply(this, arguments));
    }

    (0, _createClass3.default)(NotFound, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                pathname = _props.pathname;

            var url = '' + baseUrl + pathname;
            return (0, _jsx3.default)('div', {
                className: _NotFoundModule2.default.container + ' container'
            }, void 0, (0, _jsx3.default)('h1', {}, void 0, '404'), (0, _jsx3.default)('p', {}, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'sorry_we_cant_find'
            })), !!pathname && (0, _jsx3.default)('p', {}, void 0, (0, _jsx3.default)('i', {
                className: _NotFoundModule2.default.url
            }, void 0, '"', url, '"')), (0, _jsx3.default)(_link2.default, {
                to: baseUrl
            }, void 0, 'www.liveauctioneers.com'));
        }
    }]);
    return NotFound;
}(_react.PureComponent);

NotFound.fetchData = function () {
    return _promise2.default.resolve({});
};

exports.default = (0, _reduxAsyncConnect.asyncConnect)([{ deferred: true, promise: NotFound.fetchData }])((0, _reactRedux.connect)(mapStateToProps)(NotFound));

/***/ })

});


// WEBPACK FOOTER //
// NotFoundPage.080ba673d563cb6885de.js